/**
 * `module` for `POST /api/Docusign/addsignature`.
 * Values must match the backend contract.
 */
export enum DocusignModule {
  RoutingSlip = 0,
  /** Use when the letters flow is wired; confirm value with the API. */
  Letter = 1,
  /** `routing-slip-details` (Approve / Sign and Submit) — `POST /api/Docusign/addsignature`. */
  RoutingSlipDetails = 2,
}

/** Parsed body from addsignature (nested or flat). */
export interface DocusignAddSignatureResult {
  signingUrl: string;
  envelopeId: string;
}

/** Body from `GET /api/Docusign/download/{documentId}`. */
export interface DocusignDownloadResponse {
  success?: boolean;
  message?: string;
  fileBase64?: string;
  fileName?: string;
  /** Some APIs return PascalCase */
  FileBase64?: string;
  FileName?: string;
}

export interface DocusignDownloadResult {
  blob: Blob;
  fileName: string;
}
